import {BenchtopMaterialType} from 'components/customer/BTM/entity/BenchtopMaterialType';
import {BenchtopMaterial} from 'components/customer/BTM/entity/BenchtopMaterial';
import {BenchtopEdgeProfile} from 'components/customer/BTM/entity/BenchtopEdgeProfile';

export const mapImage = <
    T extends BenchtopMaterialType | BenchtopMaterial | BenchtopEdgeProfile
>(
    benchTopMaterial: T
) => {
    if (benchTopMaterial.image) {
        benchTopMaterial.image.name = `/${benchTopMaterial.image?.image_url}`;
    }

    return benchTopMaterial;
};
